import {
  useAnonymous,
  useCurrentModule,
  useSwitchFlows,
} from '@wix/package-picker-shared-eclipse';

export const MONEY_BACK_CTA_HOVER_SPEC = 'eclipseMoneyBackCtaHover';

export const useMoneyBackCtaHover = () => {
  const { internals } = useCurrentModule();
  const { experiments } = internals.experiments.hooks.useExperiments();
  const { isAnonymous } = useAnonymous();
  const { isSwitchFlow, isLoading: isSwitchFlowLoading } = useSwitchFlows();

  const isSpecOn =
    experiments.isEnabled(MONEY_BACK_CTA_HOVER_SPEC) && !isAnonymous;

  return {
    isEnabled: isSpecOn && !isSwitchFlowLoading && isSwitchFlow === false,
    isLoading: isSpecOn && isSwitchFlowLoading,
  };
};
